import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import DatePicker from 'react-datepicker';
import DataTable from 'react-data-table-component';
import 'react-datepicker/dist/react-datepicker.css';
import { Dropdown, Tab, Nav, Modal } from "react-bootstrap";
import { get_ContactData } from "../../../store/actions/CommanAction";
import { get_InquiryAction } from "../../../store/actions/CommanAction";
import { get_InquiryUserData } from "../../../store/actions/CommanAction";
import { useDispatch, useSelector } from "react-redux";
import Select from 'react-select';
import swal from "sweetalert";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import Swal from "sweetalert2";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from 'moment';
import { customStyles } from "../Utility/Utility";
import Loader from "../Loader/Loader";

const Contact = () => {
  const dispatch = useDispatch();
  const [editModal, setEditModal] = useState(false);
  const [selectBtn, setSelectBtn] = useState("Newest");
  const [data, setData] = useState(
    document.querySelectorAll("#reviews_wrapper tbody tr")
  );
  const [selectedItem, setSelectedItem] = useState(null);

  const sort = 25;
  const activePag = useRef(0);
  const [test, settest] = useState(0);
  const contactData = useSelector((state) => state.feedBackReducer.ContactData);
  const InquiryActionData = useSelector((state) => state.feedBackReducer.InquiryActionData)
  const InquiryUserData = useSelector((state) => state.feedBackReducer.InquiryUserData)
  const [IsActive, setIsActive] = useState("1");
  const [activeTab, setActiveTab] = useState('All');
  const [loading, setLoding] = useState(false)


 

  const [closedCurrentPage, setClosedCurrentPage] = useState(0);
  const itemsPerPage = 10;
  const closedData = contactData?.filter(item => item.Status === 'Close' || item.Status === 'Hold');



  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [filteredClosedData, setFilteredClosedData] = useState(closedData);
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [showDropdown, setShowDropdown] = useState(true);


  const paginatedClosedData = Array.isArray(filteredClosedData)
    ? filteredClosedData.slice(
      closedCurrentPage * itemsPerPage,
      (closedCurrentPage + 1) * itemsPerPage
    )
    : [];


  const [addFormData, setaddFormData] = useState({

    Comments: "",
    InquiryID: "",
    CreatedByUser: "",
    Status: "",
    EmpID: "",

  });

  useEffect(() => {
    dispatch(get_ContactData(setLoding, addFormData.Status));
  }, []);

  useEffect(() => {
    dispatch(get_InquiryAction());
  }, [])

  useEffect(() => {
    dispatch(get_InquiryUserData());
  }, [])

  useEffect(() => {

    if (closedData?.length > 0 && filteredClosedData?.length === 0) {
      setFilteredClosedData(closedData);
    }
  }, [closedData]);

  const handleAddFormSubmit = async (event) => {
    event.preventDefault();
    await AddUpdate('InquiryAction/Insert_InquiryAction', addFormData);
    swal('Good job!', 'Successfully remove', "success");
    setEditModal(false)

    if (activeTab === 'All') {
      allcustomerreviewdata();
    } else if (activeTab === 'Closed') {
      closedata();
    }

  };

  const stripHtmlTags = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const plainTextDescription = stripHtmlTags(addFormData.Comments);


  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };

  useEffect(() => {
    setData(document.querySelectorAll("#reviews_wrapper tbody tr"));

  }, [test]);


  activePag.current === 0 && chageData(0, sort);

  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);


  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    settest(i);
  };

  const chackbox = document.querySelectorAll(".sorting_1 input");
  const motherChackBox = document.querySelector(".sorting_asc_1 input");

  const chackboxFun = (type) => {
    for (let i = 0; i < chackbox.length; i++) {
      const element = chackbox[i];
      if (type === "all") {
        if (motherChackBox.checked) {
          element.checked = true;
        } else {
          element.checked = false;
        }
      } else {
        if (!element.checked) {
          motherChackBox.checked = false;
          break;
        } else {
          motherChackBox.checked = true;
        }
      }
    }
  };

  const handleEditClick = (item) => {
    setaddFormData({
      Comments: "",
      InquiryID: item.InquiryID || "",
      CreatedByUser: item.CreatedByUser || "",
      Status: item.Status || "",
      EmpID: item.EmpID || "",
    });
    setEditModal(true);
  };

  useEffect(() => {
    if (activeTab === 'Closed' && closedData) {
      setFilteredClosedData(closedData);

    }
  }, [closedData, activeTab]);

  function closedata() {
    let status = "Close" || "Hold";
    dispatch(get_ContactData(setLoding, status));
    setActiveTab('Closed');
    setFilteredClosedData(closedData);
  }

  function allcustomerreviewdata() {
    let status = "Open" || "In Progress";
    setActiveTab('All');
    dispatch(get_ContactData(setLoding, status));
  }


  const ChangeDropDown = (e, name) => {

    if (e && e.value !== undefined) {

      setaddFormData({
        ...addFormData,
        [name]: e.value
      });
    } else {

      setaddFormData({
        ...addFormData,
        [name]: null
      });
    }
  };


  const handleDateFilter = () => {
    if (startDate && endDate) {
      const start = new Date(startDate);
      start.setHours(0, 0, 0, 0);

      const end = new Date(endDate);
      end.setHours(23, 59, 59, 999);

      const filteredData = closedData.filter((item) => {
        const itemDate = new Date(item.CreatedTime);
        const isWithinRange = itemDate >= start && itemDate <= end;

        return isWithinRange;
      });

      setFilteredClosedData(filteredData);

    } else {

      setFilteredClosedData(closedData);

    }
    setActiveTab('All');
  };

  const resetFilter = () => {
    setFilteredClosedData(closedData);
    setStartDate(null);
    setEndDate(null);
  };



  const [state, setState] = useState({
    start: moment().subtract(29, 'days'),
    end: moment(),
  });

  const { start, end } = state;

  const handleCallback = (start, end) => {
    setState({ start, end });
  };
  const label =
    start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY');


  const columns = [

    {
      name: 'Customer Name',
      selector: (row) => row.Name?.toLowerCase(),
      sortable: true,
      cell: (row) => <span className="text-nowrap">{row.Name}</span>,

    },
    {
      name: 'Mobile No.',
      selector: (row) => row.Name?.toLowerCase(),
      sortable: true,
      cell: (row) => <span className="text-nowrap">{row.MobileNo}</span>,

    },
    {
      name: 'Comment',
      selector: (row) => row.InquiryMessage?.toLowerCase(),
      sortable: true,
      cell: (row) => <p className="fs-16">{row.InquiryMessage}</p>,
    },
    {
      name: 'Inquiry Related',
      selector: (row) => row.InquiryMessage?.toLowerCase(),
      sortable: true,
      cell: (row) => <p className="fs-16">{row.InquiryRelated}</p>,
    },
    // {
    //   name: 'Status',
    //   selector: (row) => row.Status?.toLowerCase(),
    //   sortable: true,
    //   cell: (row) => <p className="fs-16">{row.Status}</p>,
    // },
    {
      name: 'Date',
      selector: (row) => new Date(row.CreatedTime).toLocaleDateString(),
      sortable: true,
      cell: (row) => <p className="fs-16">{new Date(row.CreatedTime).toLocaleDateString()}</p>,
    }
    ,
    {
      name: <p className='text-end' style={{ position: 'absolute', top: '7px', right: 50 }}>Action</p>,
      cell: row => <>
        <div style={{ position: 'absolute', top: 4, right: 50 }}>
          <Dropdown>
            <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
              <Dropdown.Item onClick={() => handleEditClick(row)}>Edit</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </>
    }
  ]

  return (
    <>
     <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Contact Us</h2>
      <Tab.Container defaultActiveKey="All">
        <div className="my-4 d-flex justify-content-between align-items-center flex-wrap">
          <div className="card-action coin-tabs mb-4">
            <Nav as="ul" className="nav nav-tabs" role="tablist">
              <Nav.Item as="li" className="nav-item">
                <Nav.Link className="nav-link" onClick={allcustomerreviewdata} eventKey="All">
                  All Customer Reviews
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li" className="nav-item">
                <Nav.Link className="nav-link" onClick={closedata} eventKey="Closed">
                  Closed
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
        </div>
        <Modal className="modal fade" show={editModal} onHide={setEditModal} >
          <div className="" role="document">
            <div className="">
              <form >
                <div className="modal-header">
                  <h4 className="modal-title fs-20">Edit User Status</h4>
                  <button type="button" className="btn-close" onClick={() => setEditModal(false)} data-dismiss="modal"></button>
                </div>
                <div className="modal-body">
                  <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>
                  <div className="add-contact-box">
                    <div className="add-contact-content">
                      <div className="form-group mb-3 ">
                        <label className="form-label">Select Status</label>
                        <Select
                          name="Status"
                          menuPlacement="auto"
                          value={InquiryActionData?.filter((obj) => obj.value === addFormData?.Status) || null}

                          options={InquiryActionData}
                          onChange={(e) => ChangeDropDown(e, 'Status')}
                          placeholder="Select Status.."
                          isClearable
                        />
                      </div>
                      <div className="form-group mb-3 ">
                        <label className="form-label">Assignee</label>
                        <Select
                          name="EmpID"
                          value={InquiryUserData?.find((obj) => obj.value === addFormData?.EmpID) || null}
                          options={InquiryUserData}
                          onChange={(e) => ChangeDropDown(e, 'EmpID')}
                          placeholder="Select.."
                          isClearable

                        />
                      </div>
                      <div className="form-group mb-3">
                        <label className="form-label">Comments</label>
                        <textarea className="form-control" rows={3}></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-primary" onClick={handleAddFormSubmit}>Update</button>
                  <button type="button" onClick={() => setEditModal(false)} className="btn btn-danger"> <i className="flaticon-delete-1"></i> Close</button>
                </div>
              </form>
            </div>
          </div>
        </Modal>
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body p-0">
              <Tab.Content>
                <Tab.Pane eventKey="All">
                  <div className="table-responsive">
                    <div
                      id="reviews_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      {/* <div className="row"> */}
                      <div className="col-12 ">
                        {loading ? (
                          <Loader />
                        ) : (
                          <DataTable
                            dense
                            data={contactData}
                            columns={columns}
                            selectableRowsHighlight
                            highlightOnHover
                            pagination
                           
                            onRowClicked={(row) => {

                            }}
                         
                            persistTableHead={true}
                            noDataComponent={"There are no data to display"}
                            customStyles={customStyles}
                          />
                        )}

                      </div>
                      {/* </div> */}


                    </div>
                  </div>


                </Tab.Pane>

                {/* <Tab.Pane eventKey="Closed">
                  {closedData?.length > 0 ? (
                    <div className="">
                     
                      <div className="d-flex align-items-center">
                        <button
                          className="btn btn-primary"
                          onClick={() => setShowDateFilter(!showDateFilter)}
                        >
                          Filter by Date
                        </button>
                        {showDateFilter && (
                          <div className="d-flex align-items-center mx-3">
                            <DatePicker
                              popperPlacement="top"
                              selected={startDate}
                              onChange={(date) => setStartDate(date)}
                              selectsStart
                              startDate={startDate}
                              endDate={endDate}
                              placeholderText="Start Date"
                              className="form-control mx-1"
                              popperContainer={({ children }) => (
                                <div
                                  style={{
                                    zIndex: 9999, 
                                    position: 'relative',
                                  }}
                                >
                                  {children}
                                </div>
                              )}
                            />

                            <DatePicker
                              popperPlacement="top"
                              selected={endDate}
                              onChange={(date) => setEndDate(date)}
                              selectsEnd
                              startDate={startDate}
                              endDate={endDate}
                              minDate={startDate}
                              placeholderText="End Date"
                              className="form-control mx-3"
                              popperContainer={({ children }) => (
                                <div
                                  style={{
                                    zIndex: 9999, 
                                    position: 'relative',
                                  }}
                                >
                                  {children}
                                </div>
                              )}
                            />
                            <button
                              className="btn btn-primary mt-0 mx-4"
                              onClick={handleDateFilter}
                            >
                              Apply Filter
                            </button>
                            <button
                              className="btn btn-secondary mt-0 mx-1"
                              onClick={resetFilter}
                            >
                              Reset Filter
                            </button>
                          </div>
                        )}
                      </div>



                      <div className="row">
                        <div className="col-12 mt-2">
                          <DataTable
                            dense
                            data={filteredClosedData} 
                            columns={columns}
                            selectableRowsHighlight
                            highlightOnHover
                            pagination
                            onRowClicked={(row) => {
                          
                            }}
                         
                            noDataComponent={"There are no data to display"}
                            customStyles={customStyles}

                          />
                        </div>
                      </div>


                     
                    </div>
                  ) : (
                    <p>No data available for status 'Close'</p>
                  )}
                </Tab.Pane> */}
                <Tab.Pane eventKey="Closed">
                  {closedData?.length > 0 ? (
                    <div className="row">
                      <div className="col-12 mt-2">
                        {loading? (
                            <Loader />
                        ):(
                          <DataTable
                          dense
                          data={closedData}
                          columns={columns}
                          selectableRowsHighlight
                          highlightOnHover
                          pagination
                          noDataComponent={"There are no data to display"}
                          customStyles={customStyles}
                        />

                        )}
                       
                      </div>
                    </div>
                  ) : (
                    <p>No data available for status 'Close'</p>
                  )}
                </Tab.Pane>

                <Tab.Pane eventKey="Archived">{/* <Archived /> */}</Tab.Pane>
              </Tab.Content>
            </div>
          </div>
        </div>
      </Tab.Container >
    </>
  );
};

export default Contact;

